import * as types from "./userprofileactiontypes";
import userProfileService from "../services/userprofileservice";
import * as appActions from '../../../actions/appactions';
import * as securityActions from '../../../actions/securityactions';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions';
import * as appConstants from '../../../overrides/appconstants'
// import { persistor } from "../../../store/store";
import sharedGlobals from "../../../sharedglobals";
let pageMenuId = appUtilityFunctions.getUrlParameter('pageId');

export const updateUserProfileState = ({ name, value }) => {
  return {
    type: types.UPDATE_USER_PROFILE,
    payload: { name, value },
  }
}
export const clearChangePasswordParams = () => {
  return {
    type: types.CLEAR_PASSWORD_PARAMS,
  }
}
export const showPasswordStrengthMeter = () => {
  return {
    type: types.PASSWORD_METER_PARAMS,
  }
}

export const updateUserProfile = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await userProfileService.updateUserProfile(currentState.updateUserProfile.userFullName);
      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        return Promise.resolve(false);
      }

      dispatch(appActions.showMessage("Successfully Updated Profile !", { buttons: ['Ok'] }));
      return Promise.resolve(true);
    } catch (e) {
    }finally{
      dispatch(appActions.setLoading(false));
    }
  };
};
export const signOutUser = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await userProfileService.signOutUser();

      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        return Promise.resolve(false);
      }
      // await persistor.purge(); 
      // await persistor.flush();
      // persistor.purge()
      //   .then(() => {
      //     return persistor.flush()
      //   })
      //   .then(() => {
      //     persistor.pause()
      //   })
      //dispatch(securityActions.redirectToPage(appConstants.SYSTEM_ID));
      window.location.href=sharedGlobals.appUrls.ssoUrl+'login';
      return Promise.resolve(true);
    } catch (e) {
    }
  };
};
export const updateUserPassword = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await userProfileService.updateUserPassword(
        currentState.updateUserProfile.newPassword,
        currentState.updateUserProfile.oldPassword
      );
      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        {
          let name= "updatePasswordMessage";
          let value = message;
          await dispatch(updateUserProfileState({name, value}));
        }
        return Promise.resolve(false);
      }
      {
        let name= "updatePasswordMessage";
        let value = '';
        await dispatch(updateUserProfileState({name, value}));
      }
      dispatch(appActions.showMessage("Successfully Changed Password !", { buttons: ['Ok'] }));
     /// return Promise.resolve(true);
      console.log(sr.result);
      //  dispatch(clearChangePasswordParams());
      return true;
    } catch (e) {
    }finally{
      dispatch(appActions.setLoading(false));
    }
  };
};
const getState = (state) => {
  return state.userProfileReducer;
};